export default __webpack_public_path__ + "static/media/facebook.6cfd66bf.png";